var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYaMapsColor = function SvgYaMapsColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0.003,
    y: 0.064,
    fill: "#FC0",
    rx: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ya-maps-color_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.143,
    height: 17.143,
    x: 1.432,
    y: 1.492,
    fill: "#FC0",
    rx: 2.857
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ya-maps-color_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ya-maps-color_svg__c)",
    d: "M16.074 4.35 3.931 9.283l5.314 1.898 1.897 5.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.074 4.35 9.056 11.37l2.087 5.121z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "m8.866 11.56 2.276 4.932-.76-6.45-6.45-.758z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ya-maps-color_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.143,
    height: 17.143,
    x: 1.432,
    y: 1.492,
    fill: "#fff",
    rx: 2.857
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ya-maps-color_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.932 4.35h12.143v12.143H3.932z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ya-maps-color_svg__c",
    x1: 3.931,
    x2: 16.075,
    y1: 16.492,
    y2: 4.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF3C6"
  })))));
};
export default SvgYaMapsColor;